import { Unit, UnitBaseTypes } from "../../Units";

function InchSquared() {
  return (
    <>
      <Unit unit={UnitBaseTypes.inch} exponent={2} />
    </>
  );
}

export default InchSquared;
